import * as types from "./mutation-types";

export default {
  [types.SET_STREAM_POSITION](state, payload) {
    state.position = payload;
  },

  [types.SET_STREAM_ORDER](state, payload) {
    state.order = payload;
  },
  [types.SET_STREAM_QTD](state, payload) {
    state.qtd_position = payload;
  },
};
